<template>
  <span>Redirect</span>
</template>

<script>
  export default {
    name: "redirect",
    beforeMount () {
      //
      let self = this
      let currentState = this.$store.state.sessionGuid
      // console.log(`Current state is ${currentState}`) // debug
      let routeUri = this.$route.hash.substring(1).split('&')
      let routeUriObj = {}

      // console.log(routeUri) //debug
      routeUri.forEach(function splitFragments(fragment) {
        let splitFragment = fragment.split('=')
        // console.log(splitFragment) // debug
        routeUriObj[splitFragment[0]] = splitFragment[1]
      })

      // let uriKeys = routeUriObj.keys()

      if (currentState == routeUriObj.state && !routeUriObj.hasOwnProperty('error')) {
        let headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${routeUriObj.access_token}`
        }
        // console.log(headers) // debug
        let url = `${process.env.VUE_APP_AUTH_ROOT_URL}/users/@me`
        // console.log(url) // debug
        this.axios.get(url, { headers })
        .then (function setUserId (response) {
          let sessionUser = response.data.id
          // console.log(sessionUser) // debug
          routeUriObj.sessionUser = sessionUser
          // console.log(routeUriObj)
          self.$store.dispatch('storeSessionData', routeUriObj)

          self.$store.commit('setUserId', sessionUser)
        })
        .then (function verifyUser () {
          // verify user
          self.$store.dispatch('verifyLogin')
        })
        /* .then (function loadSearches (response) {
          console.log(response)
          // console.log(response) // debug
          let isAuthorized = self.$store.state.isAuthorized
          console.log(`Authorized = ${isAuthorized}`)
          if (isAuthorized) {
            console.log('Loading searches...')
            self.$store.dispatch('loadSearches')
          }
        }) */
      /* } else {
        this.$router.replace('/') */
      }

      this.$router.replace('/')
    }
  }

</script>

<style scoped>

</style>
